import { TrafficSourceHelper } from './TrafficSourceTrackingHelper';

const url = new URL(window.location);
const params = new URLSearchParams(window.location.search);
const trafficSourceHelper = new TrafficSourceHelper(params, url);

document.addEventListener('DOMContentLoaded', () => {
	if (trafficSourceHelper.DataStorage) {
			trafficSourceHelper.initLocalStorageInformation();
	}
});
